lmApp
  .service('AdministrationService', ['$rootScope', 'ApiService', '$timeout',
    function ($rootScope, ApiService, $timeout) {
      var service = {};

      service.Sections = {
        'application': {
          title: 'Applications',
          route: '/application',
          mode: 'none',
          isExpand: true
        },
        'content': {
          title: 'Content',
          route: '/content',
          isExpand: true,
          sections: {
            'vod': {
              title: 'VOD',
              route: '/content/vod',
              mode: 'none',
              icon: 'filmstrip'
            },
            'live': {
              title: 'Live',
              route: '/content/live',
              mode: 'none',
              icon: 'monitor'
            },
            'catchup': {
              title: 'Catchup',
              route: '/content/catchup',
              mode: 'none',
              icon: 'video-switch'
            },
            'metadata': {
              title: 'Metadata',
              route: '/content/metadata',
              mode: 'none',
              icon: 'tag-text-outline'
            },
            'packages': {
              title: 'Packages',
              route: '/content/packages',
              mode: 'none',
              icon: 'package'
            }
          }
        },
        'subscribers': {
          route: '/subscribers',
          title: 'Subscribers',
          isExpand: true,
          sections: {
            'list': {
              title: 'List',
              route: '/subscribers/list',
              mode: 'none',
              icon: 'account-multiple'
            },
            'groups': {
              title: 'Groups',
              route: '/subscribers/groups',
              mode: 'none',
              icon: 'google-circles-group'
            },
            'favorites': {
              title: 'Favorites',
              route: '/subscribers/favorites',
              mode: 'none',
              icon: 'heart'
            },
            'sessions': {
              title: 'Sessions',
              route: '/subscribers/sessions',
              mode: 'none',
              icon: 'chart-bar'
            }
          }
        },
        'restrictions': {
          route: '/restrictions',
          title: 'Restrictions',
          isExpand: true,
          sections: {
            'geoip-rules': {
              title: 'GeoIP rules',
              route: '/restrictions/geoip-rules',
              mode: 'none',
              icon: 'minus-network'
            }
          }
        },
        'npvr': {
          route: '/npvr',
          title: 'nPVR',
          isExpand: true,
          sections: {
            'records': {
              title: 'Records',
              route: '/npvr/records',
              mode: 'none',
              icon: 'record-rec'
            }
          }
        },
        'billing': {
          route: '/billing',
          title: 'Billing',
          isExpand: true,
          sections: {
            'stripeconnect': {
              title: 'Stripe',
              route: '/billing/stripeconnect',
              mode: 'none',
              icon: 'code-string'
            },
            'offers': {
              title: 'Offers',
              route: '/billing/offers',
              mode: 'none',
              icon: 'coin'
            },
            'plans': {
              title: 'Plans',
              route: '/billing/plans',
              mode: 'none',
              icon: 'cash-usd'
            }
          }
        },
        'statistic': {
          route: '/statistic',
          title: 'Statistic',
          isExpand: true,
          sections: {
            'overview': {
              title: 'Overview',
              route: '/statistic/overview',
              mode: 'none',
              icon: 'star-circle'
            },
            'reports': {
              title: 'Reports',
              route: '/statistic/reports',
              mode: 'none',
              icon: 'chart-line'
            }
          }
        },
        'epg': {
          route: '/epg',
          title: 'EPG',
          isExpand: true,
          sections: {
            'channels': {
              title: 'Channels',
              route: '/epg/channels',
              mode: 'none',
              icon: 'timetable'
            },
            'epg-import': {
              title: 'XMLTV',
              route: '/epg/epg-import',
              mode: 'none',
              icon: 'arrow-down-bold-hexagon-outline'
            }
            // 'catchup-2-0': {
            //   title: 'Catchup 2.0',
            //   route: '/epg/catchup-2-0',
            //   mode: 'none',
            //   icon: 'video-switch'
            // }
          }
        },
        'infrastructure': {
          title: 'Infrastructure',
          route: '/infrastructure',
          isExpand: true,
          sections: {
            'servers': {
             title: 'Servers',
             route: '/infrastructure/servers',
               mode: 'none',
               icon: 'server'
             }
          }
        }
      };

      service.parsedPermissions = service.Sections;

      service.ParseAccountPermissions = function (groups, notSave) {
        if (!groups) groups = $rootScope.globals.currentUser.account.groups || [];

        var permissions = angular.copy(service.Sections);

        angular.forEach(groups.filter(function (group) {

          return group !== 'admin';
        }), function (group) {
          if (!group) return;

          var mode = group.split('=');
          var split = mode[0].split(':');

          if (split.length > 1 && permissions[split[0]] && permissions[split[0]].sections && permissions[split[0]].sections[split[1]]) {
            permissions[split[0]].sections[split[1]].mode = mode[1] ? mode[1] : 'none';
          } else {
            if (!permissions[split[0]]) permissions[split[0]] = {};
            permissions[split[0]].mode = mode && mode[1] ? mode[1] : 'none';
          }

        });

        if (_.indexOf(groups, 'admin') !== -1) {
          permissions['application'].mode = $rootScope.globals.currentUser.readOnly ? 'r' : 'rw';

          for (var section in permissions) {
            if (!permissions[section].sections) {
              permissions[section].mode = $rootScope.globals.currentUser.readOnly ? 'r' : 'rw';
            } else {

              for (var subsection in permissions[section].sections) {
                permissions[section].sections[subsection].mode = $rootScope.globals.currentUser.readOnly ? 'r' : 'rw';
              }
            }
          }

          permissions['administration'] = {
            title: 'Administration',
            isExpand: true,
            sections: {
              'permissions': {
                title: 'Permissions',
                route: '/administration/permissions',
                mode: $rootScope.globals.currentUser.readOnly ? 'r' : 'rw',
                icon: 'account-star'
              }
            }
          };

          if (!_.isEmpty($rootScope.globals)
            && !_.isEmpty($rootScope.globals.currentUser)) {

            if ($rootScope.globals.currentUser.project === 'realchoice') {
              permissions['billing']['invoice'] = {
                title: 'Invoices',
                route: '/billing/invoice',
                mode: 'none',
                icon: 'file-document'
              };
            }
          }
        }

        if (_.indexOf(groups, 'infrastructure:replication=rw') !== -1) {
          permissions['administration'].sections['instances'] = {
            title: 'Syndication',
            route: '/administration/instances',
            mode: 'rw',
            icon: 'sync'
          };
        }

        if (_.indexOf(groups, 'subscribers:creation=rw') !== -1) {
          permissions['subscribers']['creation'] = true;
        }

        if (!$rootScope.infrastructure) {
          $timeout(function () {
            permissions['infrastructure'].sections['delivery-method'].mode = 'none';
          }, 350);
        }

        permissions['support'] = {
          title: 'Support',
          route: '/support',
          isExpand: true,
          sections: {
            'contacts_help': {
              title: 'Help',
              route: '/support/contacts_help',
              mode: 'rw',
              icon: 'help'
            }
          }
        };

        if (!_.isEmpty($rootScope.globals) && $rootScope.globals.currentUser.isSuperuser) {
          permissions['superuser'] = {
            admin: true,
            title: 'Superuser',
            route: '/superuser',
            isExpand: true,
            sections: {
              'operators': {
                admin: true,
                title: 'Operators',
                route: '/superuser/operators',
                mode: 'rw',
                icon: 'account-switch'
              }
            }
          };

          // permissions['infrastructure'].sections['monitoring'] = {
          //   admin: true,
          //   title: 'Monitoring',
          //   route: '/infrastructure/monitoring',
          //   mode: $rootScope.globals.currentUser.readOnly ? 'r' : 'rw',
          //   icon: 'speedometer'
          // };
        }

        var count = 0;
        for (var se in permissions) {
          if (permissions[se].sections) {
            count = 0;
            for (var sus in permissions[se].sections) {
              if (permissions[se].sections[sus].mode === 'none') count += 1;
            }

            if (_.size(permissions[se].sections) === count) {
              permissions[se].mode = 'none';
            }
          }
        }

        if (!notSave) service.parsedPermissions = permissions;

        return permissions;
      };

      service.GetParseAccountPermissions = function () {

        return service.parsedPermissions;
      };

      service.CreateAccount = function (account) {

        var data = {
          email: account.email,
          password: account.password,
          first_name: account.firstName,
          last_name: account.lastName
        };

        if (account.groups) data.groups = account.groups.join(',');

        return ApiService.Request('1/operator/account/create', 'POST', data);
      };

      service.SetAccountGroups = function (account) {

        var data = {
          account_id: account.id,
          groups: account.groups.join(',')
        };

        return ApiService.Request('1/operator/account/groups/set', 'POST', data);
      };

      service.RemoveAccount = function (account) {

        var data = {
          account_id: account.id
        };

        return ApiService.Request('1/operator/account/remove', 'POST', data);
      };

      $rootScope.$on('self:update', function (event, data) {
        service.ParseAccountPermissions();

      });

      return service;
    }]);
